import React from "react"
import styled from "styled-components"

const StyledTextArea = styled.textarea`
  font-family: var(--family);
  padding: 10px;
  opacity: 0.75;
  border-radius: 0;
  font-size: 16px;
  padding-left: 15px;
  line-height: 1.5;
  letter-spacing: 0.055em;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  box-shadow: inset 0 1px 1px 0 rgb(0 0 0 / 5%);
  background-color: #fafcfe;
  height: 120px;
  width: 100%;
  max-width: 100%;

  &:focus {
    color: rgba(4, 6, 44, 1);
    opacity: 1;
    outline: none;
  }
`

const TextArea = ({ field, ...props }) => {
  delete props.form;

  return <StyledTextArea {...field} {...props} />
}

export { TextArea }
